import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type ClassDetails } from '../modal/class';

interface UpdateArchiveStatusParams {
  id: string;
  isArchive: boolean;
}

const updateClassArchiveStatus = async ({
  id,
  isArchive,
}: UpdateArchiveStatusParams): Promise<ClassDetails> => {
  const response = await baseAPI.patch<ClassDetails>(`/enrollments/${id}/archive`, {
    isArchive,
  });
  return response.data;
};

export const useUpdateClassArchiveStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateClassArchiveStatus,
    onSuccess: () => {
      // Invalidate all queries that start with 'classes' key to refresh the data
      // This includes individual class queries, class lists, and search results
      queryClient.invalidateQueries({ queryKey: [KEYS.CLASSES] });
    },
  });
};
